/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Sources_Document_Upload_FailedInputs */



/**
* | output |
* | --- |
* | "That file was not added. Try again." |
*
* @param {Meeting_Sources_Document_Upload_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_sources_document_upload_failed = /** @type {((inputs?: Meeting_Sources_Document_Upload_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Sources_Document_Upload_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dat bestand is niet toegevoegd. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce fichier n'a pas été ajouté. Réessayez.")
	return /** @type {LocalizedString} */ ("That file was not added. Try again.")
});